module.exports = "/static/assets/df6a71244d4727d19c5a78d71677d2a6.svg";